<template>
    <div class="loader">
        <div class="lds-grid">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
        <h4><slot></slot></h4>
    </div>
</template>

<script>
    export default {
        name: "loader"
    }
</script>

<style scoped lang="scss">
    .loader {
        text-align: center;
        margin-top: 70px;

        h4 {
            text-transform: uppercase;
        }
    }
</style>